/**
 * apiClient.js
 *
 * @description Defines a way to access a preconfigured axios instance.
 *
 * @author Moshe Berman
 * @copyright 2018, Owal Inc.
 *
 * Created on 02/14/2018.
 */

import axios from 'axios'
import { store } from '@/store/store'

export const BASE_URL = 'https://api.owal.io'
export const PYTHON_BASE_URL = 'https://yakov.owal.io' // Caddy will split /api/v5 to the GPU server

/**
 * This method returns an Axios object,
 * configured with an auth token and the
 * endpoint. If no endpoint is supplied,
 * the client will use `BASE_URL` (api.owal.io)
 *
 * @export
 * @param {String} baseURL The URL to use as the root endpoint.
 */
export function owalAPIClient (baseURL = BASE_URL) {
  let config = {
    baseURL,
  }
  if (store && store.getters) {
    const token = store.getters.authToken
    axios.defaults.headers.common['authorization'] = `Bearer ${token}`
  }
  // console.debug(`Config: `, config)
  const client = axios.create(config)
  return client
}
